import { render } from "./ReportHeader.vue?vue&type=template&id=3c6f8579&scoped=true"
import script from "./ReportHeader.vue?vue&type=script&lang=js"
export * from "./ReportHeader.vue?vue&type=script&lang=js"

import "./ReportHeader.vue?vue&type=style&index=0&id=3c6f8579&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6f8579"]])

export default __exports__